export default __webpack_public_path__ + "static/media/2024_orien.3ac24423.pdf";